<template>
<form @submit.prevent="handleSubmit" method="GET" action="/" class="search-form w-full max-w-xl px-4">
    <input type="search" name="s" placeholder="Search..." v-model="searchTerm" class="border-solid border-b-2 border-white appearance-none rounded-none bg-transparent inline-block w-full text-2xl text-white p-2 vt:p-4 hover:border-secondary-500 focus:border-secondary-500">
</form>
</template>

<script>
import { Inertia } from '@inertiajs/inertia';
import { ref } from 'vue';

export default {

    setup(props, {emit}) {

        const searchTerm = ref('');
        const handleSubmit = async (e) => {
            let url = "/?s=" + searchTerm.value;
            let announce = new CustomEvent("goingSomewhereElse", {
                detail: {
                    href: url
                }
            });
            emit('searching');
            window.dispatchEvent(announce);
            await window.wait(380);
            Inertia.get(url);
        };

        return {
            handleSubmit,
            searchTerm
        };

    }

}
</script>